import {Device, DeviceType} from 'smag-commons/cfg/connector/mqtt';

export enum MqttEnergyProfile {
    CONSUMER = 'Consumer',
    PRODUCER_PROSUMER = 'Producer/Prosumer',
}

export interface MqttMeasures {
    absorptionMeasures: string[];
    injectionMeasures: string[];
    productionMeasures: string[][]; // one `string` array for each plant (M2 meter)
}

export interface MqttDeviceWrapper<MeasureType> {

    deviceType: DeviceType;

    maxProductionPlants: number;

    measureTypes: Set<MeasureType>;

    getMqttMeasures(): MqttMeasures;

    getMeasureType(measId: string): MeasureType;

    setMeasureType(measId: string, measureType: MeasureType);

    setDefaultMeasures(profile: MqttEnergyProfile, productionPods?: string[]);

    formatMeasureType(measureType: MeasureType): string;
}

export function mkDeviceWrapper<MeasureType>(ctor: MqttDeviceWrapperFactory<MeasureType>, devId: string, device: Device) {
    return new ctor(devId, device);
}

interface MqttDeviceWrapperFactory<MeasureType> {

    new(devId: string, device: Device): MqttDeviceWrapper<MeasureType>;
}
